import { useState } from 'react'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { login, register } from '../api'

export default function LoginPage() {
  const [mode, setMode] = useState<'login' | 'register'>('login')
  const [email, setEmail] = useState('')
  const [password, setPassword] = useState('')
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()
  const notice = (location.state as { notice?: string } | null)?.notice

  async function onSubmit(e: React.FormEvent) {
    e.preventDefault()
    setError('')
    setLoading(true)
    try {
      if (mode === 'register') {
        await register(email, password)
      } else {
        await login(email, password)
      }
      navigate('/create', { replace: true });
        window.dispatchEvent(new Event('auth-refresh'))
    } catch (err) {
      setError(err instanceof Error ? err.message : '操作失败')
    } finally {
      setLoading(false)
    }
  }

  return (
    <section className="section">
      <div className="auth-wrap">
        <div className="panel">
          <h2 className="panel-title">EMAIL LOGIN</h2>
          <p className="muted">使用邮箱和密码即可，无需验证邮件。每人每日有生成额度。</p>

          {notice ? <div className="alert alert-info">{notice}</div> : null}

          <div className="auth-tabs">
            <button
              type="button"
              className={mode === 'login' ? 'active' : ''}
              onClick={() => setMode('login')}
            >
              登录
            </button>
            <button
              type="button"
              className={mode === 'register' ? 'active' : ''}
              onClick={() => setMode('register')}
            >
              注册
            </button>
          </div>

          {error ? <div className="alert alert-error">{error}</div> : null}

          <form onSubmit={onSubmit}>
            <div className="field" style={{ marginBottom: '1rem' }}>
              <label htmlFor="email">邮箱</label>
              <input
                id="email"
                type="email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
                placeholder="you@example.com"
                autoComplete="email"
                required
              />
            </div>
            <div className="field" style={{ marginBottom: '1.15rem' }}>
              <label htmlFor="password">密码</label>
              <input
                id="password"
                type="password"
                value={password}
                onChange={(e) => setPassword(e.target.value)}
                placeholder="至少 6 位"
                autoComplete={mode === 'register' ? 'new-password' : 'current-password'}
                required
              />
            </div>
            <button className="btn btn-primary" type="submit" disabled={loading} style={{ width: '100%' }}>
              {loading ? '请稍候…' : mode === 'register' ? '注册并开始' : '登录'}
            </button>
          </form>

          <p className="muted" style={{ marginTop: '1rem', marginBottom: 0 }}>
            先逛逛？ <Link to="/">返回首页</Link>
          </p>
        </div>
      </div>
    </section>
  )
}
